<template>
  <div class="mcf-window">
    <div class="mcf-header">
      <div class="mcf-header-left">
        <div class="mcf-header-left-menu">
          <i class="fa fa-grip"></i>
        </div>
        <div class="mcf-header-left-title">
          <label>{{title}}</label>
        </div>
      </div>
      <div class="mcf-header-center">
        <div class="mcf-search">
          <div class="mcf-search-icon">
            <i class="fa fa-search"></i>
          </div>
          <div class="mcf-search-content">
            <input type="text" placeholder="Rechercher">
          </div>
        </div>
      </div>
      <div class="mcf-header-right">
        <ul>
          <li @click="change_theme"><i class='fa fa-cog'></i></li>
          <li><i class='fa fa-user'></i></li>          
        </ul>
      </div>
    </div>
    <div class="mcf-appwindow">
      <div class="mcf-ribbon">
        <div class="mcf-ribbon-left">
          <div class="mcf-ribbon-group" v-if="!is_form_active">
            <div class="mcf-ribbon-group-buttons">
              <button class="mcf-ribbon-button-new">
                <i class="fa fa-plus"></i>
                <label>Nouveau</label>
              </button>
            </div>
            <div class="mcf-ribbon-group-title">
              <label>Client</label>
            </div>
          </div>
          <div class="mcf-ribbon-group" v-if="is_form_active">
            <div class="mcf-ribbon-group-buttons">
              <button @click="bt_new" class="mcf-ribbon-button-new">
                <i class="fa fa-plus"></i>
                <label>Nouveau</label>
              </button>
              <button @click="bt_edit" class="mcf-ribbon-button-large">
                <i class="fa fa-edit"></i>
                <label>Modifier</label>
              </button>
              <button @click="bt_print" class="mcf-ribbon-button-large">
                <i class="fa fa-print"></i>
                <label>Imprimer</label>
              </button>
              <button @click="bt_delete" class="mcf-ribbon-button-large">
                <i class="fa fa-trash"></i>
                <label>Supprimer</label>
              </button>              
            </div>
            <div class="mcf-ribbon-group-title">
              <label>Client</label>
            </div>
          </div>
          <div class="mcf-ribbon-group" v-if="is_form_active">
            <div class="mcf-ribbon-group-buttons">
              <button @click="bt_localize" class="mcf-ribbon-button-large">
                <i class="fas fa-map-marker-alt"></i>
                <label>Localiser</label>
              </button>
              <button @click="bt_call" class="mcf-ribbon-button-large">
                <i class="fas fa-phone"></i>
                <label>Appeler</label>
              </button>
              <button @click="bt_sendmail" class="mcf-ribbon-button-large">
                <i class="fas fa-envelope"></i>
                <label>Envoyer</label>
              </button>
              <button class="mcf-ribbon-button-large">
                <i class="fa fa-plus"></i>
                <label>Devis</label>
              </button>
              <button class="mcf-ribbon-button-large">
                <i class="fa fa-plus"></i>
                <label>Facture</label>
              </button>
            </div>
            <div class="mcf-ribbon-group-title">
              <label>Actions</label>
            </div>
          </div>
          <div class="mcf-ribbon-group" v-if="is_form_active">
            <div class="mcf-ribbon-group-buttons">
              <button @click="bt_state(0)" :class="{'mcf-ribbon-button-large':(1==1),'mcf-ribbon-button-disabled':(form.is_inactive==0)}">
                <i class="fa fa-thumbs-up"></i>
                <label>Actif</label>
              </button>
              <button @click="bt_state(1)" :class="{'mcf-ribbon-button-large':(1==1),'mcf-ribbon-button-disabled':(form.is_inactive==1)}">
                <i class="fa fa-ban"></i>
                <label>Bloquer</label>
              </button>
            </div>
            <div class="mcf-ribbon-group-title">
              <label>Etat</label>
            </div>
          </div>
        </div>
        <div class="mcf-ribbon-right">
          <div class="mcf-ribbon-group">
            <div class="mcf-ribbon-group-buttons">
              <button @click="bt_close" class="mcf-ribbon-button-large">
                <i class="fa fa-close"></i>
                <label>Fermer</label>
              </button>
            </div>
            <div class="mcf-ribbon-group-title">
              <label>Application</label>
            </div>
          </div>
        </div>
      </div>
      <div class="mcf-appwindow-content">
        <div class="mcf-page" v-if="is_form_active">
          <div class="mcf-page-line-entete">
            <div @click="bt_edit" class="cust-header  mcf-page-line-edit">
              <h1>{{form.company}}</h1>
              <label>{{form.address1}} {{form.zipcode}} {{form.city}}</label>
              <label>{{form.phone}}</label>
              <label>{{form.email}}</label>
            </div>
            <div @click="bt_upload_logo" class="cust-logo mcf-page-line-edit">
              <div v-if="logo==''" class="cust-logo-empty">
                <i class='fa fa-image'></i>
                <label>Insérer un logo</label>
              </div>
              <div v-if="logo!=''" class="cust-logo-content">
                <img :src="logo">
              </div>
            </div>
          </div>
          <div class="mcf-page-line-1" style="margin-top:30px;">
            <div class="mcf-page-line-title">
              <h1><i class='fa fa-file-invoice'></i> Factures</h1>
            </div>
            <table class="mcf-table-salelines" style="margin-top:10px;">
              <thead>
                <tr>
                  <th></th>
                  <th>Numéro</th>
                  <th>Date</th>
                  <th>Type de document</th>
                  <th>Etat</th>
                  <th>Montant</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="s of form.lists.invoices" :key="s.id">
                  <td @click="bt_invoice_select(s.id)" style="cursor:pointer;width:32px;padding:5px;text-align:center;"><i class='fa fa-search'></i></td>
                  <td style="padding:5px;text-align:left;">{{s.invoice_number}}</td>
                  <td style="padding:5px;text-align:center;">{{$filters.mdate(s.invoice_date,account.lang)}}</td>
                  <td style="padding:5px;text-align:left;">{{lg[s.label]}}</td>
                  <td style="padding:5px;text-align:left;">{{lg[s.state]}}</td>
                  <td style="padding:5px;text-align:right;" class="mcf-table-salelines-number">{{$filters.money(s.total_ttc,account.lang)}}</td>
                </tr>
              </tbody>
              <tbody v-if="form.lists.invoices.length==0">
                <tr>
                  <td colspan="6" style="text-align:center;padding:20px;">Vous n'avez pas de factures pour ce client</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="mcf-page-line-1" style="margin-top:30px;">
            <div class="mcf-page-line-title">
              <h1><i class='fa fa-file-lines'></i> Devis de vente</h1>
            </div>
            <table class="mcf-table-salelines" style="margin-top:10px;">
              <thead>
                <tr>
                  <th></th>
                  <th>Numéro</th>
                  <th>Date</th>
                  <th>Type de document</th>
                  <th>Etat</th>
                  <th>Montant</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="s of form.lists.sales" :key="s.id">
                  <td @click="bt_sale_select(s.id)" style="cursor:pointer;width:32px;padding:5px;text-align:center;"><i class='fa fa-search'></i></td>
                  <td style="padding:5px;text-align:left;">{{s.sale_number}}</td>
                  <td style="padding:5px;text-align:center;">{{$filters.mdate(s.sale_date,account.lang)}}</td>
                  <td style="padding:5px;text-align:left;">{{lg[s.label]}}</td>
                  <td style="padding:5px;text-align:left;">{{lg[s.state]}}</td>
                  <td style="padding:5px;text-align:right;" class="mcf-table-salelines-number">{{$filters.money(s.total_ttc,account.lang)}}</td>
                </tr>
              </tbody>
              <tbody v-if="form.lists.sales.length==0">
                <tr>
                  <td colspan="6" style="text-align:center;padding:20px;">Vous n'avez pas de devis de vente pour ce client</td>
                </tr>
              </tbody>
            </table>
          </div>          
        </div>
      </div>
    </div>
    <customers_edit v-if="app_action=='edit'" :account="account" :customer="form_tmp" :cancel="evt_customers_edit_cancel" :save="evt_customers_edit_save"></customers_edit>
    <uploadfilebox v-if="app_action=='upload'" :setting="dialog_setting"></uploadfilebox>
    <pdfbox v-if="app_action=='print'" :setting="dialog_setting" :close="evt_customers_edit_cancel"></pdfbox>
    <dialogbox v-if="dialog_show" :setting="dialog_setting"></dialogbox>
    <loadingbox v-if="loading"></loadingbox>
  </div>
</template>

<script>
import apiaccount from "../../core/data/account";
import tools from "../../core/data/tools";
import translation from "../../core/data/lang";
import apicustomer from "../../core/data/customer";
import dialogbox from "../../core/controls/ui-dialogbox";
import loadingbox from "../../core/controls/ui-loadingbox";
import pdfbox from "../../core/controls/ui-pdfbox";
import uploadfilebox from "../../core/controls/ui-uploadfilebox";
import customers_edit from "./customers-edit.vue";

export default {
  components:{ 
    dialogbox,loadingbox,pdfbox,uploadfilebox,customers_edit
  },
  data(){
    return {
      loading:false,
      lang:'fr-FR',
      dialog_show:false,
      dialog_setting:{},
      app_action:'',
      title:'Clients',
      account:{},
      logo:"",
      form:{},
      form_tmp:{}
    }
  },
  computed: {
    is_form_active: function(){
      return (JSON.stringify(this.form) != '{}');
    },
    lg: function(){
      return translation.get(this.lang);
    }
  },
  created: async function(){
    var tmain = this;
    tmain.loading = true;
    tools.set_title('Macrofox - Clients');
    tools.set_background('light');
    tools.set_theme('green');
    var pkg = await apiaccount.info();
    if (pkg.code==0){
      tmain.account = pkg.data;
      if (localStorage.getItem("id")!=undefined){
        var pget = await apicustomer.get(localStorage.getItem("id"));
        if (pget.code==0){
          tmain.form = pget.data;
          var pkgfile = await apicustomer.file_download(tmain.form.id,'logo.png');
          if (pkgfile.byteLength<=35){
            tmain.logo = "";
          }else{
            tmain.logo = window.URL.createObjectURL(new Blob([pkgfile],{ type: 'image/png' }));
          }
          tmain.loading = false;
        }
      }else{
        tmain.$router.push({path:'/home'});
      }
    }else{
      tmain.$router.push({path:'/'});
    }
  },
  methods:{
    change_theme: async function(){
      this.account.theme = (this.account.theme=='light' ? 'dark' : 'light');
      var pkg = await apiaccount.update(this.account);
      if (pkg.code==0){
        tools.set_background(this.account.theme);
      }      
    },
    bt_new: async function(){
      var tmain = this;
      tmain.dialog_setting = {
        icon:'fa fa-plus',
        title:'Nouveau',
        message:'Voulez-vous créer un client ?',
        buttons:[
          {
            label:'Oui',
            fx:async function(){
              var pkg = await apicustomer.new();
              if (pkg.code==0){
                tmain.form = pkg.data;
                tmain.form_tmp = {};
                tmain.dialog_setting = {};
                tmain.dialog_show=false;
                tmain.logo ="";
                localStorage.setItem("id",tmain.form.id);
              }
            }
          },
          {
            label:'Non',
            fx:function(){
              tmain.dialog_show=false;
            }
          }
        ]
      };
      tmain.dialog_show=true;
    },
    bt_edit: function(){
      var tmain = this;
      tmain.form_tmp = Object.assign({},tmain.form);
      tmain.app_action="edit";
    },
    bt_print: async function(){
      var tmain = this;
      tmain.loading = true;
      var pkgfile = await apicustomer.print('CUSTOMER',tmain.form.id);
      var fileURL = window.URL.createObjectURL(new Blob([pkgfile],{ type: 'application/pdf' }));
      tmain.loading=false;
      tmain.app_action = 'print';
      tmain.dialog_setting = {
        icon:'fa fa-print',
        title:tmain.form.company,
        data:fileURL,
        buttons:[]
      };
    },
    bt_delete:async function(){
      var tmain = this;
      tmain.dialog_setting = {
        icon:'fa fa-trash',
        title:'Supprimer',
        message:'Voulez-vous supprimer ce client '+tmain.form.company+' ?',
        buttons:[
          {
            label:'Oui',
            fx:async function(){
              var pkg = await apicustomer.delete([{id:tmain.form.id}]);
              if (pkg.code==0){
                if (pkg.data.length>0){
                  alert('impossible de supprimer ce client');
                }else{
                  tmain.form = {};
                  tmain.form_tmp = {};
                  tmain.dialog_setting = {};
                  localStorage.clear();
                  tmain.logo = "";
                  tmain.dialog_show=false;
                }
              }
            }
          },
          {
            label:'Non',
            fx:function(){
              tmain.dialog_show=false;
            }
          }
        ]
      };
      tmain.dialog_show=true;
    },
    bt_localize: function(){
      var tmain = this;
      window.open("https://www.google.fr/maps/search/" + tmain.form.address1 + " " + tmain.form.zipcode +" " + tmain.form.city,"_blank");
    },
    bt_call: function(){
      var tmain = this;
      window.open("tel:" + tmain.form.phone,"_blank");
    },
    bt_sendmail: function(){
      var tmain = this;
      window.open("mailto:" + tmain.form.email,"_blank");
    },
    bt_state: function(value){
      this.form.is_inactive=value;
      this.evt_customers_edit_save(this.form);
    },
    bt_close: function(){
      var tmain = this;
      tmain.$router.push({path:'/home'});
    },
    bt_upload_logo: async function(){
      var tmain = this;
      var dlg = {
        icon:'fa fa-info-circle',
        extension:'image/*',
        title:'Veuillez insérer une image',
        id:tmain.form.id,
        change:async function(id,arrayfile,file){
          await apicustomer.file_upload(tmain.form.id,file);
          var pkgget = await apicustomer.get(tmain.form.id);
          if (pkgget.code==0){
            tmain.form = pkgget.data;
            var pkgfile = await apicustomer.file_download(tmain.form.id,'logo.png');
            if (pkgfile.byteLength<=35){
              tmain.logo = "";
            }else{
              tmain.logo = window.URL.createObjectURL(new Blob([pkgfile],{ type: 'image/png' }));
            }
          }else{
            console.log('error');
          }
          tmain.dialog_setting = {};
          tmain.app_action = '';
        },
        cancel:function(){
          tmain.dialog_setting = {};
          tmain.app_action = '';
        }
      };
      tmain.dialog_setting = dlg;
      tmain.app_action = 'upload';
    },
    bt_invoice_select: function(id){
      localStorage.setItem("id",id);
      this.$router.push({path:'/invoice'});
    },
    bt_sale_select: function(id){
      localStorage.setItem("id",id);
      this.$router.push({path:'/sale'});
    },
    evt_customers_edit_cancel:function(){
      this.form_tmp={};
      this.app_action='';
    },
    evt_customers_edit_save: async function(item){
      var tmain = this;
      tmain.loading = true;
      tmain.form_tmp = {};
      tmain.app_action = "";
      var pkg = await apicustomer.save(item);
      if (pkg.code==0){
        var pkgget = await apicustomer.get(item.id);
        if (pkgget.code==0){
          tmain.form = pkgget.data;          
        }else{
          console.log('error');
        }
      }else{
        console.log('error');
      }
      tmain.loading = false;
    }
  }
}
</script>

<style scoped>

.cust-header{
    padding:20px;
    text-align:left;
}

.cust-header>h1{
    font-size:20px;
    color:var(--C1);
}

.cust-header>label{
    font-size:12px;
}

.cust-logo{
  height: 100%;
  width:100%;
}

.cust-logo-empty{
  border:solid 1px #ddd;
  border-radius: 5px;
  width:calc(100% - 40px);
  height:calc(100% - 40px);
  margin-right:20px;
  margin-left:20px;
  margin-top:20px;
  text-align:center;
}

.cust-logo-empty>i{
  color:var(--C2);
  margin-top:20px;
}

.cust-logo-empty>label{
  font-size:12px;
}

.cust-logo-content{
  border:solid 1px #ddd;
  border-radius: 5px;
  width:calc(100% - 40px);
  height:calc(100% - 40px);
  margin-right:20px;
  margin-left:20px;
  margin-top:20px;
  text-align:center;
}

.cust-logo-content>img{
  width: auto;
  height: 100%;
  max-width: 180px;
  object-fit: contain;
}

</style>